export const translation = {
  en: {
    PORTFOLIOS: 'Portfolios',
    ACCOUNTS: 'Accounts',
    PRINT_PDF: 'Print/PDF',
    EXPORT_CSV: 'Export (CSV)',
    NEXT: 'Next',
    BACK: 'Back',
    CALCULATE: 'Calculate',
  },
  fr: {
    PORTFOLIOS: 'Portefeuilles',
    ACCOUNTS: 'Comptes',
    PRINT_PDF: 'Imprimer/PDF',
    EXPORT_CSV: 'Exporter (CSV)',
    NEXT: 'Suivant',
    BACK: 'Retour',
    CALCULATE: 'Calculer',
  },
};
